import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M672.274 547.699V889.681L371.706 760.866C332.318 747.272 297.441 723.083 270.907 690.958 244.373 658.833 227.209 620.015 221.301 578.769 215.392 537.524 220.969 495.447 237.417 457.164 253.866 418.883 280.55 385.876 314.537 361.771 348.524 337.668 388.498 323.399 430.066 320.536 471.634 317.672 513.187 326.323 550.158 345.538 587.13 364.753 618.089 393.788 639.632 429.453 661.176 465.119 672.47 506.033 672.274 547.699zM959.895 1550.52C1013.45 1550.76 1065.35 1531.95 1106.32 1497.47 1147.3 1462.98 1174.68 1415.06 1183.6 1362.25 1192.51 1309.44 1182.37 1255.17 1154.98 1209.16 1127.6 1163.13 1084.75 1128.34 1034.08 1110.97L733.516 982.161V1324.15C733.584 1384.17 757.456 1441.7 799.895 1484.15 842.335 1526.59 899.876 1550.46 959.895 1550.52zM226.887 1097.53C182.052 1097.47 138.21 1110.72 100.908 1135.6 63.6045 1160.47 34.5168 1195.85 17.3245 1237.26.13224 1278.67-4.39211 1324.24 4.32386 1368.21 13.0399 1412.19 34.6045 1452.61 66.2896 1484.32 97.9747 1516.04 138.356 1537.65 182.325 1546.42 226.295 1555.19 271.876 1550.71 313.303 1533.57 354.73 1516.42 390.14 1487.37 415.054 1450.1 439.968 1412.82 453.266 1368.99 453.266 1324.16 453.199 1264.12 429.335 1206.55 386.902 1164.08 344.47 1121.59 286.929 1097.66 226.887 1097.53zM1693.14 1550.52C1746.69 1550.76 1798.6 1531.95 1839.57 1497.47 1880.54 1462.98 1907.93 1415.06 1916.85 1362.25 1925.75 1309.44 1915.62 1255.17 1888.23 1209.16 1860.85 1163.13 1818 1128.34 1767.33 1110.97L1466.51 982.161V1324.15C1466.64 1384.19 1490.57 1441.72 1533.05 1484.16 1575.53 1526.59 1633.1 1550.46 1693.14 1550.52zM1405.53 547.689V889.671L1104.7 760.856C1065.35 747.221 1030.51 723.005 1004.02 690.865 977.527 658.724 960.404 619.905 954.531 578.67 948.656 537.434 954.261 495.378 970.726 457.12 987.192 418.861 1013.88 385.879 1047.87 361.798 1081.85 337.716 1121.81 323.465 1163.37 320.611 1204.92 317.757 1246.46 326.408 1283.41 345.617 1320.37 364.825 1351.33 393.847 1372.86 429.495 1394.41 465.143 1405.71 506.038 1405.53 547.689z"
});

var IconMasteryLogoLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMasteryLogoLine, _Component);

  var _super = _createSuper(IconMasteryLogoLine);

  function IconMasteryLogoLine() {
    _classCallCheck(this, IconMasteryLogoLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMasteryLogoLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMasteryLogo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMasteryLogoLine.displayName = "IconMasteryLogoLine";
  return IconMasteryLogoLine;
}(Component);

IconMasteryLogoLine.glyphName = 'mastery-logo';
IconMasteryLogoLine.variant = 'Line';
IconMasteryLogoLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMasteryLogoLine;
export { IconMasteryLogoLine };